import axios from "axios";

//IMPORT API ROUTE URL
import { GET_AUTO_SUGGESSION_LIST } from "./apiRoutes";

const getAutoSuggession = (type, keyword) => {
  var postData = new FormData();

  postData.append("type", type);
  postData.append("keyword", keyword);

  return axios
    .post(GET_AUTO_SUGGESSION_LIST, postData, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return false;
    });
};

export default getAutoSuggession;
